
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { getQiNiuYunToken } from "@/api/http";
import { ElMessage } from "element-plus";
import { Request } from "@/api/request";
const qiniu: any = require("qiniu-js");

export default defineComponent({
    name: "MechanicAdd",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["师傅展示"]);
        const route = useRoute();
        const router = useRouter();
        let form = ref({
                name: "",
                label: "",
                experience: "",
                headimgurl: "",
            } as any),
            formRef = ref(null),
            formLoading = ref(false),
            img = ref({ url: "", key: "" }),
            id: any = null,
            token = "",
            bucketURL = "",
            imgLoading = ref(false),
            rules = {
                img: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            if (img.value.key) {
                                callback();
                            } else {
                                callback(new Error("请上传师傅照片"));
                            }
                        },
                        trigger: "change",
                    },
                ],
                experience: [
                    {
                        required: true,
                        message: "请输入经验",
                        trigger: "change",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入师傅名称",
                        trigger: "change",
                    },
                ],
                label: [
                    {
                        required: true,
                        message: "请输入标签",
                        trigger: "change",
                    },
                ],
            };

        let beforeAvatarUpload = (file: File) => {
                const isJPG = file.type === "image/jpeg";
                const isPNG = file.type === "image/png";
                if (!isJPG && !isPNG) {
                    ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                }
                return isJPG && isPNG;
            },
            uploadImg = (file: any) => {
                let config = {
                    useCdnDomain: true,
                    // region: qiniu.region.z2,
                };
                let putExtra = {
                    fname: "",
                    params: {},
                    mimeType: null,
                };
                let observable: any = {};
                observable = qiniu.upload(file, null, token, putExtra, config);

                const observer = {
                    next(res: any) {},
                    error(err: any) {},
                    complete(res: any) {
                        img.value.url = bucketURL + res.key;
                        img.value.key = res.key;
                    },
                };
                observable.subscribe(observer);
            },
            handleChange = (file: any, type: boolean) => {
                img.value = {
                    url: "",
                    key: "",
                };
                uploadImg(file.raw);
            },
            imgLoad = () => {
                imgLoading.value = false;
            },
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let data = {
                            ...form.value,
                        },
                        url = 'adminapi/Employee/create'
                        data.headimgurl = img.value.key;
                        if (Object.keys(route.query).length > 0) {
                            data = {
                                ...data,
                                id,
                            };
                            url = '/adminapi/Employee/edit'
                        }
                        
                        Request.axiosInstance({
                            url,
                            data
                        }).then(res => {
                            if(res.status == 202){
                                router.back()
                            }
                        })
                    }
                });
                // console.log(form.value);
            };

        onMounted(() => {
            getQiNiuYunToken().then((res: any) => {
                token = res.content.token;
                bucketURL = res.content.domain;
            });
            if (Object.keys(route.query).length > 0) {
                formLoading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Employee/editInfo",
                    data: {
                        id: route.query.id,
                    },
                }).then((res: any) => {
                    // tableData.value = res?.content?.list || [];
                    formLoading.value = false;
                    if (res.status == 200) {
                        Object.keys(form.value).forEach((key) => {
                            form.value[key] = res.content.info[key];
                        });
                        id = res.content.info.id;
                        img.value = res.content.info.headimgurl;
                    }
                });
            }
        });

        return {
            form,
            formRef,
            rules,
            formLoading,
            beforeAvatarUpload,
            img,
            imgLoading,
            imgLoad,
            handleChange,
            onSubmit,
        };
    },
});
